import { API_ROUTES } from "./ApiRoutes";
import { apiClient } from "./http.api";

export const authApi = {
  // Login user with form-data (username, password)
  login: async (credentials) => {
    const formData = new FormData();
    formData.append('username', credentials.email || credentials.username);
    formData.append('password', credentials.password);
    formData.append('grant_type', 'password');

    const response = await apiClient.post(API_ROUTES.AUTH.LOGIN, formData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });
    return response.data;
  },

  // Logout user
  logout: async () => {
    try {
      const response = await apiClient.post(API_ROUTES.AUTH.LOGOUT);
      return response.data;
    } catch (error) {
      // Even if logout fails on server, clear local storage
      console.warn('Server logout failed, but clearing local storage:', error.message);
      return { message: 'Logged out successfully' };
    }
  },

  // Get current user info
  getCurrentUser: async () => {
    const response = await apiClient.get(API_ROUTES.AUTH.GET_CURRENT_USER);
    return response.data;
  },

  // Change organization
  changeOrganization: async (organizationId) => {
    const response = await apiClient.post(API_ROUTES.AUTH.CHANGE_ORGANIZATION, {
      new_organization_id: organizationId
    });
    return response.data;
  },

  // Forgot password
  forgotPassword: async (email) => {
    const response = await apiClient.post(API_ROUTES.AUTH.FORGOT_PASSWORD, { email });
    return response.data;
  },

  // Reset password
  resetPassword: async (token, newPassword, confirmPassword) => {
    const response = await apiClient.post(API_ROUTES.AUTH.RESET_PASSWORD, {
      secret_token: token,
      new_password: newPassword,
      confirm_password: confirmPassword
    });
    return response.data;
  },

  // SSO redirect
  getSSORedirect: async () => {
    const response = await apiClient.get(API_ROUTES.AUTH.SSO_REDIRECT);
    return response.data;
  },
};

// Export individual functions for backward compatibility
export const {
  login,
  logout,
  getCurrentUser,
  changeOrganization,
  forgotPassword,
  resetPassword,
  getSSORedirect,
} = authApi;
